const K = 1000
const M = K * K
const K100 = 100 * K

type Ranges = Array<[number, number, number]>

export const CASH_RANGE: Ranges = [
  [0, 10 * K, K / 2],
  [10 * K, K100, K],
  [K100, 5 * K100, 20 * K],
  [M, 3 * M, M / 2],
]

export default (ranges: Ranges): number[] => {
  const values = new Set<number>()

  ranges.forEach(([start, end, batch]) => {
    for (let price = start; price <= end; price += batch) {
      values.add(price)
    }
  })

  return Array.from(values)
}
